import pixQrCode from "../assets/pix-qrcode.png";
import { Lang, t } from "../i18n/translations";

interface Props { lang: Lang; }

export default function Support({ lang }: Props) {
  const tr = t[lang].supportPage;
  const pix = lang === "pt" ? t.pt.pixCard : null;

  return (
    <div className="support-page">
      <h1 className="support-title">{tr.title}</h1>
      <p className="support-sub">{tr.sub}</p>
      {pix && (
        <div className="pix-card">
          <div className="pix-card-header">
            <div>
              <div className="support-role">{pix.role}</div>
              <p className="support-desc">{pix.desc}</p>
            </div>
          </div>
          <div className="pix-card-body">
            <p className="pix-label">{pix.label}</p>
            <img src={pixQrCode} alt="QR Code PIX" className="pix-qrcode" />
            <p className="pix-hint">{pix.hint}</p>
          </div>
        </div>
      )}

      <div className="support-tiers">
        {tr.tiers.map((tier, i) => (
          <div className={`support-card support-card--${i}`} key={i}>
            <span className="support-emoji">{tier.emoji}</span>
            <div className="support-amount">{tier.amount}</div>
            <div className="support-role">{tier.role}</div>
            <p className="support-desc">{tier.desc}</p>
            <a className="btn btn-primary support-cta" href={tier.url} target="_blank" rel="noreferrer">
              {tier.cta}
            </a>
          </div>
        ))}
      </div>
      <p className="support-note">
        {lang === "pt"
          ? "Pagamento seguro via Stripe. Nenhum dado é armazenado por nós."
          : "Secure payment via Stripe. No data is stored by us."}
      </p>
    </div>
  );
}
